export const translatePartyRole = (partyRole) => {
    const partyRoleTranslations = {
        Pedestrian: "Piéton",
        InsuredDriver: "Conducteur Assuré",
        AdverseDriver: "Conducteur Adverse",
        Passenger: "Passager",
        Witness: "Témoin",
        Garage: "Garage",
        Inspector: "Inspecteur",
        Agent: "Agent",
    };
    return partyRoleTranslations[partyRole] || partyRole;
};